import StorageRepository from "../../../domain/fundamentals/storage/StorageRepository";
import LocalStorageDataSource from "../../../infrastructure/datasource/storage/LocalStorageDataSource";

export default class DeleteAuthentication {
  private static STORAGE_KEY: string = "autoLoginData";

  constructor(private readonly repository: StorageRepository = new LocalStorageDataSource()) {
  }

  public execute(): void {
    this.repository.deleteBy(DeleteAuthentication.STORAGE_KEY);
  }
}